module.exports = __webpack_public_path__ + "img/icon_instagram_swipe_up.3d53b7da.svg";